/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import {
  Box,
  MenuItem,
  FormControl,
  Select,
  ListSubheader,
  Button,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/system";
import { StoreContext } from "../../../../../../../../../../../store/StoreProvider";
import Act from "../../../../../../../../../../../store/actions";
import { prepareEditDialog } from "../../../../../../../utils/prepareEditDialog";
import { aiPageConfig } from "../../../../../textConfig";
import { editDialogConfig } from "../../../../../../../constants/textConfig";
import closeIcon from "../../../../../../../../../../../../images/ai_image/closeIcon.svg";
import addIcon from "../../../../../../../../../../../../images/ai_image/addIcon.svg";

const EventSelect = ({ curMainEvn, curSubEvn, curRowId, type }) => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { tableData } = sna.AI;
  const events = sna.filter.eventTypes.initial;

  const [mainEvns, setMainEvns] = useState([]);
  const [subEvns, setSubEvns] = useState([]);
  const anchorRef = useRef(null);

  const SelectStyles = {
    "& .MuiSelect-icon": {
      display: "none",
    },
    "& .MuiInputBase-input": {
      padding: "8px",
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "8px",
      borderColor: "transparent",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3BBFF0",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3BBFF0",
    },
  };

  const StyledMenuItem = styled(MenuItem)({
    padding: "8px 8px 8px 12px",
    fontSize: "14px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  });

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 238,
        width: anchorRef.current ? anchorRef.current.clientWidth : "auto",
        minWidth: "165px",
      },
    },
  };

  const handleClick = (eventType) => {
    if (eventType === aiPageConfig.mainEvn) {
      prepareEditDialog(dispatch, editDialogConfig.addMainEvn.name, {
        curMainEvn,
        curRowId,
      });
    } else if (eventType === aiPageConfig.subEvn) {
      prepareEditDialog(dispatch, editDialogConfig.addSubEvn.name, {
        curMainEvn,
        curRowId,
      });
    }
  };

  const handleChange = (e) => {
    const newTableData = tableData.map((el) =>
      el.id === curRowId
        ? {
            ...el,
            [type]: e.target.value,
            ...(type === aiPageConfig.mainEvn && { subEvn: "" }),
          }
        : el
    );
    dispatch({
      type: Act.SNA_SET_AI_TABLE_DATA,
      payload: newTableData,
    });
  };

  const handleClear = () => {
    const newTableData = tableData.map((el) =>
      el.id === curRowId
        ? {
            ...el,
            [type]: "",
            ...(type === aiPageConfig.mainEvn && { subEvn: "" }),
          }
        : el
    );
    dispatch({
      type: Act.SNA_SET_AI_TABLE_DATA,
      payload: newTableData,
    });
  };

  const renderMainEvnOptions = () => {
    if (!mainEvns) return null;
    return mainEvns.map((el) => (
      <StyledMenuItem key={el.id} value={el.name}>
        {el.name}
      </StyledMenuItem>
    ));
  };

  const renderSubEvnOptions = () => {
    if (!mainEvns) return null;
    const foundCurMainEvn = mainEvns.find((el) => el.name === curMainEvn);
    if (!foundCurMainEvn) return null;
    const filteredSubEvn = subEvns.filter(
      (el) => el.pid === foundCurMainEvn.evtTypeId
    );
    if (!filteredSubEvn) return null;
    return filteredSubEvn.map((el) => (
      <StyledMenuItem key={el.id} value={el.name}>
        {el.name}
      </StyledMenuItem>
    ));
  };

  useEffect(() => {
    const filteredMainEvns = events.filter((e) => e.pid === "EVTTYPE0");
    const filteredSubEvns = events.filter((e) => e.pid !== "EVTTYPE0");
    setMainEvns(filteredMainEvns);
    setSubEvns(filteredSubEvns);
  }, [events]);

  return (
    <Box sx={{ position: "relative" }}>
      <FormControl fullWidth>
        <Select
          disabled={type === aiPageConfig.subEvn && !curMainEvn}
          defaultValue=""
          value={type === aiPageConfig.mainEvn ? curMainEvn : curSubEvn}
          onChange={handleChange}
          sx={SelectStyles}
          MenuProps={MenuProps}
          fullWidth
          ref={anchorRef}
          displayEmpty
          renderValue={(selected) =>
            selected === "" ? (
              <span
                style={{
                  color: "#888888",
                  fontWeight: 400,
                  fontSize: "14px",
                }}
              >
                {type === aiPageConfig.subEvn ? "請選擇子事件" : "請選擇"}
              </span>
            ) : (
              selected
            )
          }
        >
          {type === aiPageConfig.mainEvn
            ? renderMainEvnOptions()
            : renderSubEvnOptions()}
          <ListSubheader
            sx={{
              borderTop: "#E7E7E7 1px solid",
              borderBottom: "#E7E7E7 1px solid",
              backgroundColor: "white",
              position: "sticky",
              bottom: 0,
              zIndex: 1,
              padding: "0",
            }}
          >
            {(type === aiPageConfig.mainEvn ||
              (type === aiPageConfig.subEvn && curMainEvn)) && (
              <Button
                sx={{
                  width: "100%",
                  padding: "8px 24px 8px 16px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#121212",
                  fontSize: "14px",
                  "&:hover": {
                    backgroundColor: "#E7E7E7",
                  },
                }}
                onClick={() => handleClick(type)}
              >
                <img src={addIcon} alt="Add" style={{ marginRight: "8px" }} />
                {type === aiPageConfig.mainEvn
                  ? aiPageConfig.addNewMainEvnTitle
                  : aiPageConfig.addNewSubEvnTitle}
              </Button>
            )}
          </ListSubheader>
        </Select>
        {(type === aiPageConfig.mainEvn ? curMainEvn : curSubEvn) && (
          <IconButton
            onClick={handleClear}
            sx={{
              position: "absolute",
              right: "8px",
              top: "50%",
              transform: "translateY(-50%)",
              padding: "4px",
            }}
          >
            <img
              src={closeIcon}
              alt=""
              style={{ width: "15px", height: "15px" }}
            />
          </IconButton>
        )}
      </FormControl>
    </Box>
  );
};

export default EventSelect;

EventSelect.propTypes = {
  curMainEvn: PropTypes.string,
  curSubEvn: PropTypes.string,
  curRowId: PropTypes.number,
  type: PropTypes.string,
};

EventSelect.defaultProps = {
  curMainEvn: PropTypes.string,
  curSubEvn: PropTypes.string,
  curRowId: PropTypes.number,
  type: PropTypes.string,
};
